import { render, staticRenderFns } from "./EventClose.vue?vue&type=template&id=bc85efa2&scoped=true"
import script from "./EventClose.vue?vue&type=script&lang=ts"
export * from "./EventClose.vue?vue&type=script&lang=ts"
import style0 from "./EventClose.vue?vue&type=style&index=0&id=bc85efa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc85efa2",
  null
  
)

export default component.exports